
export default {
  props: {
    link: {
      type: String,
      default: '/',
    },
  },
}
